import React from 'react'
import Geosuggest from 'react-geosuggest'

import { Bounds, ComponentWithModal } from 'discover'

export class LocationSelection extends ComponentWithModal {
  onSelect = (obj) => {
    var bounds
    // If the user accepts/tabs an empty field, we select the "neutral" thing
    // by default
    if (obj.label === '') {
      obj.label = LocationSelection.neutralLabel
    }
    // Select the bounds depending on the label
    if (obj.label === LocationSelection.neutralLabel) {
      bounds = null
    }
    else if (obj.gmaps.geometry.bounds) {
      bounds = Bounds.fromGoogleBounds(obj.gmaps.geometry.bounds, obj.label)
    }
    else if (obj.gmaps.geometry.viewport) {
      bounds = Bounds.fromGoogleBounds(obj.gmaps.geometry.viewport, obj.label)
    }
    this.props.boundsChanged(bounds)
    this.hideModal()
  }

  componentDidUpdate() {
    if (this.modalInputRef) this.modalInputRef.focus()
  }

  options() {
    const neutralOption = { title: LocationSelection.neutralLabel }
    return [neutralOption].concat(this.props.locations)
  }

  static get neutralLabel() {
    return I18n.t('discover.categories.index.all_locations')
  }

  modal() {
    if (!this.state.isModalActive) return null

    const fixtures   = this.options().map(l => ({label: l.title, className: 'is-fixture'})),
          biasBounds = new google.maps.LatLngBounds({lat: 47, lng: 6}, {lat: 55, lng: 15})

    return <Geosuggest
             bounds={ biasBounds }
             fixtures={ fixtures }
             onSuggestSelect={ this.onSelect }
             placeholder={ I18n.t('discover.categories.index.location_input_hint') }
             types={[ 'geocode' ]}
             ref={ (r) => { this.modalInputRef = r; } }
           />
  }

  render() {
    const ButtonClass = this.props.buttonClass

    return (
      <div className='location-selection'>
        <ButtonClass showModal={ this.showModal } bounds={ this.props.bounds } />
        { this.modalBackground() }
        { this.modal() }
      </div>
    )
  }
}
